<template>
    <Header>
        <slot>
            <div class="bg-blue-100 text-white" ref="target">
                <div class="max-w-6xl mx-auto flex justify-center align-center">
                    <div class="menu-item" :class="{ active: isPage == 'personales' }">
                        <router-link :to='{name: hasPurchasedPlan == true ? "Membresia" : "Profile"}'  class="flex align-center content-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 sm:h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clip-rule="evenodd" />
                            </svg>
                            <span class="ml-1 hidden sm:block">{{ checkoutTranslate[language].tabs.information }}</span>
                        </router-link>
                    </div>
                    <div class="menu-item" :class="{ active: isPage == 'resumen' }">
                        <router-link :to='{name: hasPurchasedPlan == true ? "Membresia" : "Subscription"}'  class="flex align-center content-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 sm:h-6" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
                            <path fill-rule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" clip-rule="evenodd" />
                            </svg>
                            <span class="ml-1 hidden sm:block">{{ checkoutTranslate[language].tabs.summary }}</span>
                        </router-link>
                    </div>
                    <div class="menu-item" :class="{ active: isPage == 'membresia' }">
                        <router-link  :to='{name: hasPurchasedPlan == true ? "Membresia" : "Subscription"}' class="flex align-center content-center justify-center cursor-disable">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-8  sm:h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd" />
                            </svg>
                            <span class="ml-1 hidden sm:block">{{ checkoutTranslate[language].tabs.membership }}</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </slot>
    </Header>
</template>

<script>

import Header from '@/components/header/Header.vue'
import { checkoutTranslate } from '@/translations/Checkout.js'
import { computed } from '@vue/reactivity';
import { useStore } from 'vuex';

  export default {
    props: ['isPage'],
    components:{
        Header
    },
   setup(){
        const language = computed( ()=> {
            return  localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es';
        })
        const store = useStore()

        const hasPurchasedPlan =  computed( ()=> { return store.state.Plans.hasPurchased })
        return { language, checkoutTranslate, hasPurchasedPlan }
   }
  };
</script>

<style scoped>
.menu-item a{
    @apply px-10 py-2 sm:py-4 font-semibold text-base border-b-4 border-transparent opacity-50 hover:opacity-100 hover:border-yellowGreen;
}
.menu-item.active a{
    @apply opacity-100 border-yellowGreen;
}
</style>